/* eslint-disable react/destructuring-assignment, react/prop-types, no-unused-vars */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import keyBy from 'lodash/keyBy';
import WealthEditGuesser from '../../base/components/guesser/wealth-edit.guesser';
import LocalStorage, { REDIRECT_KEY } from '../../services/local-storage';
import BrandForm from './components/BrandForm';
import { useTransformBrandData } from './components/utils';
import { INVOICE_SERVICE } from '../../constant/invoice';

const BrandEdit = (props) => {
  const classes = useStyles();
  const transformBrandData = useTransformBrandData();

  const transform = (data) => {
    const { group, ...transformedData } = transformBrandData(data);

    return transformedData;
  };

  /**
   * To redirect to player state management detail page after setting up the Get Player Token Url successfully
   */
  const redirectTo = LocalStorage.getItem(REDIRECT_KEY);

  useEffect(
    () => () => {
      /**
       * To clear redirect url to player state management detail page
       */
      LocalStorage.removeItem(REDIRECT_KEY);
    },
    [],
  );

  return (
    <WealthEditGuesser
      {...props}
      transform={transform}
      redirectUrl={redirectTo}
      custom
      className={classes.wrapper}
      initialValues={(record) => {
        const royalty = keyBy(record?.royalty || [], 'invoiceService');
        return {
          monthlyRoyalty: royalty[INVOICE_SERVICE.MONTHLY_GGR]?.value,
          mktRoyalty: royalty[INVOICE_SERVICE.MKT_FREE_SPIN]?.value,
          currenciesConfig: record?.currencies?.map?.(({ royalty, ...otherData }) => {
            const currencyRoyalty = keyBy(royalty || [], 'invoiceService');
            return {
              ...otherData,
              monthlyRoyalty: currencyRoyalty[INVOICE_SERVICE.MONTHLY_GGR]?.value,
              mktRoyalty: currencyRoyalty[INVOICE_SERVICE.MKT_FREE_SPIN]?.value,
            };
          }),
        };
      }}
    >
      <BrandForm />
    </WealthEditGuesser>
  );
};

export default BrandEdit;

const useStyles = makeStyles({
  wrapper: {
    maxWidth: '960px',
    width: '100%',
    margin: 'auto',
  },
});
